import { combineReducers } from "redux";

// reducers
import authReducer from "./auth/reducer";
import marketReducer from "./market/reducer";
import settingsReducer from "./settings/reducer";
import walletReducer from "./wallet/reducer";

export default combineReducers({
  authReducer,
  marketReducer,
  settingsReducer,
  walletReducer,
});
